import { Injectable, inject } from '@angular/core';

import { LaunchDarklyFlagManagerService } from '@frontend/sports/launch-darkly/feature';
import { SchemaMarkupBoostrapService } from '@frontend/sports/schema-markup/feature';
import { PerformanceProfilingService } from '@frontend/sports/tracking/feature/performance-tracker';
import { SportsClientConfigRefreshService, UserAccountIdCookieService, UserServiceWatcher } from '@frontend/sports/user/feature';
import { OnAppInit } from '@frontend/vanilla/core';

import { RewardTokensBannerService } from '../../betslip/modules/reward-tokens/services/reward-tokens-banner.service';
import { BreadcrumbsBoostrapService } from '../breadcrumbs/breadcrumbs-bootstrap';
import { CrmPromotionProviderService } from '../crm-promotion/crm-promotion-provider.service';
import { OddAcceptanceModeFilterService } from '../dont-accept-stake-option-settings/odd-accept-mode-filter.service';
import { NativeEventSubscription } from '../native-alerts/native-event-subscription.service';
import { RewardTokenWidgetRegistration } from '../reward-tokens/widget-registration.service';
import { SettingsService } from '../settings/settings.service';
import { SubNavigationBootstrapService } from '../sub-navigation/sub-navigation.bootstrap';
import { RealityCheckService } from '../user/services/reality-check.service';
import { AnimationDisabledService } from './animation-disable.service';
import { BackgroundWorkerManagerService } from './background-worker-manager.service';
import { BottomNavBootstrapService } from './bottom-nav-bootstrap.service';
import { CriticalErrorBootstrapService } from './critical-error-bootstrap.service';
import { PopupInitializationService } from './initialize-popup.service';
import { IntroPagesBootstrapService } from './intro-pages-bootstrap';
import { LayoutBootstrapService } from './layout-bootstrap.service';
import { LazySportsConfigLoaderService } from './lazy-sports-config-loader.service';
import { OrientaionChangeService } from './orientation-change.service';
import { SetFeatureClassesService } from './set-feature-styles.service';
import { SlotLayoutRouteOverrideService } from './slot-layout.bootstrap.service';
import { ToggleBottomNavService } from './toggle-bottom-nav.service';

@Injectable({
    providedIn: 'root',
})
export class SportsWebBootstrapService implements OnAppInit {
    private animationDisabledService = inject(AnimationDisabledService);
    private criticalErrorBootstrapService = inject(CriticalErrorBootstrapService);
    private setFeatureClassesService = inject(SetFeatureClassesService);
    private orientaionChangeService = inject(OrientaionChangeService);
    private layoutBootstrapService = inject(LayoutBootstrapService);
    private sportsClientConfigRefreshService = inject(SportsClientConfigRefreshService);
    private nativeEventSubscription = inject(NativeEventSubscription);
    private popupInitializationService = inject(PopupInitializationService);
    private introPagesBootstrapService = inject(IntroPagesBootstrapService);
    private bottomNavBootstrapService = inject(BottomNavBootstrapService);
    private breadcrumbsBoostrapService = inject(BreadcrumbsBoostrapService);
    private schemaMarkupBoostrapService = inject(SchemaMarkupBoostrapService);
    private subNavigationBootstrapService = inject(SubNavigationBootstrapService);
    private slotLayoutRouteOverrideService = inject(SlotLayoutRouteOverrideService);
    private performanceProfilingService = inject(PerformanceProfilingService);
    private realityCheckService = inject(RealityCheckService);
    private userStateService = inject(UserServiceWatcher);
    private toggleBottomNav = inject(ToggleBottomNavService);
    private rewardTokensBannerService = inject(RewardTokensBannerService);
    private backgroundWorkerManagerService = inject(BackgroundWorkerManagerService);
    private settingsService = inject(SettingsService);
    private rewardTokenWidgetRegistration = inject(RewardTokenWidgetRegistration);
    private lazySportsloaderService = inject(LazySportsConfigLoaderService);
    private crmPromotionProviderService = inject(CrmPromotionProviderService);
    private oddAcceptanceModeFilterService = inject(OddAcceptanceModeFilterService);
    private launchDarklyFlagManagerService = inject(LaunchDarklyFlagManagerService);
    private userAccountIdCookieService = inject(UserAccountIdCookieService);

    async onAppInit(): Promise<any> {
        this.crmPromotionProviderService.onAppInit();
        await this.lazySportsloaderService.onAppInit();
        this.slotLayoutRouteOverrideService.onAppInit();
        this.animationDisabledService.onAppInit();
        this.criticalErrorBootstrapService.onAppInit();
        this.setFeatureClassesService.onAppInit();
        this.orientaionChangeService.onAppInit();
        this.performanceProfilingService.onAppInit();
        this.realityCheckService.onAppInit();
        this.layoutBootstrapService.onAppInit(); // Execute after store
        this.sportsClientConfigRefreshService.onAppInit();
        this.nativeEventSubscription.onAppInit();
        this.launchDarklyFlagManagerService.onAppInit();
        this.popupInitializationService.onAppInit();
        this.introPagesBootstrapService.onAppInit();
        this.bottomNavBootstrapService.onAppInit();
        this.breadcrumbsBoostrapService.onAppInit();
        this.schemaMarkupBoostrapService.onAppInit();
        this.subNavigationBootstrapService.onAppInit();
        this.toggleBottomNav.onAppInit();
        this.settingsService.onAppInit();
        this.rewardTokensBannerService.onAppInit();
        this.rewardTokenWidgetRegistration.onAppInit();
        this.userStateService.onAppInit(); // Execute after store and User bootstrap
        // run it last in order to know that everything is created for our background workers.
        this.backgroundWorkerManagerService.onAppInit();
        this.oddAcceptanceModeFilterService.onAppInit();
        this.userAccountIdCookieService.onAppInit();
    }
}
